import ApiResponse from "sr/models/ApiResponse";
import { post } from "../axios";
import { toast } from "react-toastify";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
export const sendOTP = async (postData: any) => {
    try {
        return await post<ApiResponse<[]>>('/auth/sendotp', postData).then((res) => {
            if (res.success === true) {
                SuccessMessage("API.SUCCESS.OTP.SEND")
                return res
            }
            else {
                if (res.error?.message?.includes('PROVIDER.ERROR') && postData.channel == 'sms') {
                    toast.error('API.ERROR.PROVIDER.ERROR_MOBILE')
                } else {
                    toast.error(res.error.message)
                }

                return null
            }
        })
    }
    catch (e: any) {
        if (e?.response?.data?.msg?.includes('PROVIDER.ERROR') && e?.response?.data?.error?.includes("Error: Invalid 'To' Phone Number") && postData.channel == 'sms') {
            HandleApiError({ response: { data: { msg: 'PROVIDER.ERROR_MOBILE' } } });
            return null
        }
        HandleApiError(e);
        return null
    }
};
